import {Vue, Component, Prop } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'chart-table',
})

export default class ChartTable extends Vue {

    // -------------------------------------------------------------
    // Properties
    @Prop()
    private data: any;

    @Prop()
    private cardName!: string;


    // -----------------------------------------------------------------
    // Actions

    public onHighlightChart(i: number) {
        d3.select(`.ct-tb-${i}-chart-${this.cardName}`).dispatch(
          'mouseover',
        );
      }
      public onMove(i: number) {
        d3.select(`.ct-tb-${i}-chart-${this.cardName}`).dispatch(
          'mouseout',
        );
      }

}
